// @core/api/endpoints/subscription/create_subscription_item.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSubscriptionItemRequest,
  SubscriptionItemResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Add item to subscription
 * Adds a new line item to the subscription such as an addon, seat pack, or metered component.
 */
export async function CreateSubscriptionItem(
  subscription_id: string,
  data: CreateSubscriptionItemRequest,
  options?: RequestOptions
): Promise<SubscriptionItemResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/items`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<SubscriptionItemResponse>(requestPath, data, requestOptions);
}
